import Head from 'next/head';
import { AppProps } from 'next/app';
import { GetServerSideProps } from 'next/types';
import { getSnapshot } from 'mobx-state-tree';
import React from 'react';

import HTMlHead from './Head';

import { initializeStorage, IStorageSnapshotIn, Provider } from '@/models/Storage';
import '@/styles/globals.scss';

export type Props = {
    initialState: IStorageSnapshotIn;
};

export default function Home(props: AppProps & { err: any }): JSX.Element {
    const { Component, pageProps, err } = props;
    let initialState = pageProps.initialState as IStorageSnapshotIn | undefined;

    const storage = initializeStorage(initialState);

    const title = 'В Арктику на практику';

    return (
        <>
            <Head>
                <title>{title}</title>
                <HTMlHead
                    title={title}
                    description={'Приключения студентов-маркшейдеров на краю земли'}
                />
            </Head>
            <div
                dangerouslySetInnerHTML={{
                    __html: `
				<!-- Yandex.Metrika counter -->
				<script type="text/javascript" >
				   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
				   m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
				   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
				
				   ym(53131834, "init", {
				        clickmap:true,
				        trackLinks:true,
				        accurateTrackBounce:true,
				        webvisor:true
				   });
				</script>
				<noscript><div><img src="https://mc.yandex.ru/watch/53131834" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
				<!-- /Yandex.Metrika counter -->  
				
				<script type="text/javascript">
				        var _gaq = _gaq || [];
				        _gaq.push(["_setAccount", "UA-28292940-1"]);
				        _gaq.push(["_setDomainName", "pikabu.ru"]);
				        _gaq.push(["_setAllowLinker", true]);
				        _gaq.push(["_trackPageview"]);
				        (function () {
				                var ga = document.createElement("script"); ga.type = "text/javascript"; ga.async = true;
				                ga.src = ("https:" == document.location.protocol ? "https://" : "http://") + "stats.g.doubleclick.net/dc.js";
				                var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ga, s);
				        })();
				</script>
                `,
                }}
            />
            <Provider value={storage}>
                <Component {...pageProps} err={err} />
            </Provider>
        </>
    );
}

export const getServerSideProps: GetServerSideProps<Props> = async (context) => {
    // constants { } = context.query;
    let initialState = undefined;

    const storage = initializeStorage(initialState);

    return {
        props: {
            initialState: getSnapshot(storage),
        },
    };
};
